import { render, staticRenderFns } from "./BottomSheetAllocate.vue?vue&type=template&id=7d55d24e&scoped=true&"
import script from "./BottomSheetAllocate.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAllocate.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAllocate.vue?vue&type=style&index=0&id=7d55d24e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d55d24e",
  null
  
)

export default component.exports